import { ReactNode, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { Box, Button, Typography } from '@mui/material';

import { DefaultLayout } from 'modules/layout/components/DefautLayout';
import { TopBannersHeightProvider } from 'modules/layout/components/TopBannersHeightProvider';

import { useErrorStyles } from './useErrorStyles';

interface IErrorProps {
  title?: string;
  buttonText?: string;
  toLocation?: 'refresh' | string;
  hasLayout?: boolean;
  description?: ReactNode;
  buttonHandler?: () => void;
}

export const Error = ({
  buttonHandler,
  buttonText,
  description,
  hasLayout = true,
  title,
  toLocation = 'refresh',
}: IErrorProps) => {
  const { classes } = useErrorStyles();
  const navigate = useNavigate();

  const defaultHandler = useCallback(() => {
    if (!toLocation) return;

    if (toLocation === 'refresh') {
      window.location.reload();
    } else {
      navigate(toLocation);
    }
  }, [navigate, toLocation]);

  const content = useMemo(() => {
    return (
      <Box className={classes.root}>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="h4" className={classes.description}>
          {description}
        </Typography>
        <Button
          size="large"
          onClick={
            typeof buttonHandler === 'function' ? buttonHandler : defaultHandler
          }
        >
          {buttonText}
        </Button>
      </Box>
    );
  }, [
    buttonHandler,
    buttonText,
    classes.description,
    classes.root,
    classes.title,
    defaultHandler,
    description,
    title,
  ]);

  if (hasLayout) {
    return (
      <TopBannersHeightProvider>
        <DefaultLayout hasError>{content}</DefaultLayout>;
      </TopBannersHeightProvider>
    );
  }

  return <>{content}</>;
};
